const PRIOR_LOGIN_COOKIE = 'endchess-prior-login';
const MAX_AGE_SEC = 10 * 365 * 24 * 60 * 60;

function priorLoginCookieSuffix(): string {
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:';
  return `path=/; max-age=${MAX_AGE_SEC}; samesite=lax${secure ? '; secure' : ''}`;
}

export function hasLoggedInBefore(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.cookie
    .split(';')
    .some((entry) => entry.trim().startsWith(`${PRIOR_LOGIN_COOKIE}=`));
}

export function markLoggedInBefore(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${PRIOR_LOGIN_COOKIE}=1; ${priorLoginCookieSuffix()}`;
}
